module.exports = __webpack_public_path__ + "img/img0403.c3debcd0.png";